var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { RetrieverChooser } from "./RetrieverChooser";
export class Retriever {
    constructor(bff, dataProvider, deviceChangeDispatcherMock) {
        this.leagues = [];
        this.retrieverChooser = new RetrieverChooser(bff, dataProvider, this.updateLeagues);
        this.isLoading = false;
        this.deviceChangeDispatcherMock = deviceChangeDispatcherMock;
    }
    setRegionId(regionId) {
        this.leaguesRetriever.setRegionIds(regionId);
    }
    removeRegionId() {
        this.leaguesRetriever.removeRegionId();
    }
    activate() {
        this.clearData();
        this.deviceChangeDispatcherMock && this.deviceChangeDispatcherMock.activate();
    }
    selectRetriever(sportId, leagueIds) {
        this.isLoading = true;
        this.leaguesRetriever = this.retrieverChooser.selectRetriever(sportId, leagueIds);
        this.leaguesRetriever.loadData();
    }
    updateLeagues(leagues) {
        this.isLoading = false;
        this.leagues = leagues;
    }
    clearData() {
        this.leagues = observable([]);
    }
    deactivate() {
        this.clearData();
        this.deviceChangeDispatcherMock && this.deviceChangeDispatcherMock.deactivate();
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "leagues", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Retriever.prototype, "isLoading", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateLeagues", null);
//# sourceMappingURL=Retriever.js.map